import { IDisplayScore } from '@/interfaces/display-score.interface';
import { IStudyStoreGetters } from '@/interfaces/store/study-store/study-store.getters.interface';
import { IStudyStoreState } from '@/interfaces/store/study-store/study-store.state.interface';
import {
	AdvicePresentation,
	BestFitResult,
	IAdvice,
} from '@studyportals/bestfit-api-fe-client';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';
import { TrackedLink } from '@studyportals/domain-client';
import { StudyStoreState } from '../../enums/study-store-state';

export const studyStoreGetters = (
	state: IStudyStoreState,
): IStudyStoreGetters => {
	return {
		fit: (): Map<ScoreDeterminantType, BestFitResult> | null => state.fit,
		scoreByDeterminant: (determinant: ScoreDeterminantType): number | null => {
			const score = state?.fit
				?.get(ScoreDeterminantType.OVERALL_FIT)
				?.breakdown?.get(determinant);

			return score !== undefined ? Math.trunc(score * 100) : null;
		},
		adviceByDeterminant: (
			determinant: ScoreDeterminantType,
		): IAdvice<AdvicePresentation, AdvicePresentation> | null => {
			const advice = state.fit?.get(1)?.advice?.get(determinant);

			return advice ?? null;
		},
		storeState: (): StudyStoreState => state.storeState,
		studyTitle: (): string | null => state.studyTitle,
		referralLink: (): TrackedLink | null => state.referralLink,
		isPremium: (): boolean | null => state.isPremium,
		universityTitle: (): any => state.universityTitle,
		organizationId: (): number | null => state.organizationId,
		displayScore: (score: number): IDisplayScore => {
			const tens = Math.round(score / 10) * 10;
			const roundedScore = tens === 100 ? 90 : tens;

			return {
				label: '',
				score: roundedScore,
			};
		},
	};
};
